import {DARK_MODE_MEDIA_QUERY} from '@zzng/common/constants/mediaQuery';
import {getOsVersion, isAndroid, isIOS} from '@zzng/common/utils/agent';

const ANDROID_SUPPORT_VERSION = 10;
const IOS_SUPPORT_VERSION = 13;
const APP_DARK_MODE_UA = '{isDark property}';

const isUnsupportedPrefersColorScheme = async () => {
  const {major} = await getOsVersion();
  return isAndroid ? major < ANDROID_SUPPORT_VERSION : isIOS && major < IOS_SUPPORT_VERSION;
};

const insertDarkClassInBody = () => {
  // prefers-color-scheme 값을 확인 해 시스템의 컬러모드 초기값으로 사용
  if (window.matchMedia(DARK_MODE_MEDIA_QUERY).matches) {
    window.document.body.classList.add('dark');
  }

  // css media query 동작과 유사하게, 시스템의 컬러모드가 변경될 때 마다 이를 웹에 반영
  const mediaQueryList = window.matchMedia(DARK_MODE_MEDIA_QUERY);
  mediaQueryList.addEventListener('change', (e) => {
    if (e.matches) {
      window.document.body.classList.add('dark');
    } else {
      window.document.body.classList.remove('dark');
    }
  });
};

export const initDarkMode = async () => {
  // 웹뷰 대응을 위해 dark mode 앱팀과 상의 필요
  const isDarkMode = window.navigator.userAgent.includes(APP_DARK_MODE_UA);
  const isUnsupportedMediaQuery = await isUnsupportedPrefersColorScheme();

  if (isDarkMode) {
    window.document.body.classList.add('dark');
  }

  if (isUnsupportedMediaQuery) {
    insertDarkClassInBody();
  }
};
